/* Minimal Portfolio — strict uniform 2-column grid, square thumbs,
   captions only on hover. Single tiny eyebrow. The uniformity IS the
   voice — no asymmetry, no headlines, no breaks. */

import { useSiteSettings } from "@/hooks/useSiteSettings";
import { getFocalStyle } from "@/lib/focal";

export default function MinimalPortfolio() {
  const { settings } = useSiteSettings();
  const portfolio = settings?.portfolio_images || [];
  const focals = settings?.portfolio_focal_points || [];

  return (
    <div className="bg-[#FAF9F6] text-[#0E0D0C] min-h-screen pt-24 pb-32" data-testid="minimal-portfolio">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-[10px] uppercase tracking-[0.42em] text-[#0E0D0C]/55 mb-20 text-center" data-testid="minimal-portfolio-eyebrow">
          The Work
        </div>

        {portfolio.length === 0 ? (
          <p className="text-center italic text-[#0E0D0C]/55 py-32" style={{ fontFamily: "var(--tenant-serif)" }}>
            No work published yet.
          </p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#0E0D0C]/8">
            {portfolio.map((src, i) => (
              <figure
                key={`${src}-${i}`}
                className="relative aspect-square bg-[#FAF9F6] overflow-hidden group"
                data-testid={`minimal-portfolio-tile-${i}`}
              >
                <img
                  src={src}
                  alt=""
                  loading={i < 4 ? "eager" : "lazy"}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                  style={getFocalStyle(focals, i)}
                />
                <figcaption className="absolute inset-x-0 bottom-0 px-5 py-3 text-[10px] uppercase tracking-[0.32em] text-white bg-gradient-to-t from-black/55 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  Plate {String(i + 1).padStart(2, "0")}
                </figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
